<template>
  <div class="p-4">
    <div id="carouselCoordinadores" class="carousel slide carousel-fade" data-ride="carousel" style="height: 400px;">
      <div class="carousel-inner" style="height: 100%;">
        <template v-for="(imagen, index) in imagenes">
          <div :key="index" class="carousel-item" :class="index == 0 ? 'active' : ''" style="border-radius:7px; height: 100%;">
            <div class="d-none d-sm-block" style="height: 100%;">
              <img 
                style="border-radius:7px; width: 100%; height: 100%; object-fit: cover;" 
                class="d-block" 
                :src="`${filesUrl}${imagen.ruta}`" 
                :alt="`Imagen coordinador ${imagen.voluntariadoCoordinadorImagenId}`" 
              />
            </div>
            <div class="d-block d-sm-none" style="height: 100%;">
              <img 
                style="border-radius:7px; width: 100%; height: 100%; object-fit: cover;" 
                class="d-block" 
                :src="`${filesUrl}${imagen.ruta}`" 
                :alt="`Imagen coordinador ${imagen.voluntariadoCoordinadorImagenId}`" 
              />
            </div>
          </div>
        </template>
      </div>
      <button class="carousel-control-prev" type="button" data-target="#carouselCoordinadores" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previo</span>
      </button>
      <button class="carousel-control-next" type="button" data-target="#carouselCoordinadores" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Siguiente</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "view-coordinadores-imagenes",
  data: () => ({
    imagenes: [],
  }),
  methods: {
    fetchImagenes: function() {
      this.$http.get(this.apiRoute("Volunteering", "GetVoluntariadoCoordinadorImagens")).then(function(response) {
        if (!response.body.error) {
          // Filtrar solo las imágenes que se muestran (seMuestra = true)
          this.imagenes = response.body.data.filter(imagen => imagen.seMuestra);
          // Ordenar por prioridad
          this.imagenes.sort((a, b) => a.prioridad - b.prioridad);
        }
      });
    },
  },
  mounted: function() {
    this.fetchImagenes();
  },
};
</script>
